module.exports = __webpack_public_path__ + "static/media/HSP40_distance_matrix.ef2c8b07.csv";